import React from "react";
import styles from "./Dashboard.module.css";
import Slider from "../Slider";
import { useStories } from "../Story/StoryHooks";
import Loading from "../Loading/Loading";

const Library = ({ title, page }) => {
  const [stories, loading] = useStories({
    type: title,
    query: {
      pagination: 20,
      page: page,
    },
  });

  return (
    <section className={title === "" ? styles.first : ""}>
      <React.Fragment>
        <h5 className={styles.sectionHeader}>{title}</h5>
        {!loading ? <Slider dashboard={true} data={stories} /> : <Loading />}
      </React.Fragment>
    </section>
  );
};

export default Library;
